import { generateUseContext } from '@guiker/react-framework'

import { DirectDebitPADContext } from '../context'

export const useDirectDebitPADContext = generateUseContext(DirectDebitPADContext)
